import { createSelector } from '@reduxjs/toolkit';

const selectWebhooks = (state) => state.webhooks.webhooks;

export const selectWebhookFilters = (state) => state.webhooks.filters;

/**
 * The listing after the filters, applied here: the backend answers the whole
 * list, unpaginated.
 */
export const selectFilteredWebhooks = createSelector(
  [selectWebhooks, selectWebhookFilters],
  (webhooks, { search, status }) => {
    const term = search.trim().toLowerCase();
    return webhooks.filter(
      (webhook) =>
        (!status || webhook.status === status) &&
        (!term || String(webhook.url || '').toLowerCase().includes(term))
    );
  }
);

/**
 * @param {number|string} id - From the address, so possibly a string.
 */
export const selectWebhookById = (id) => (state) =>
  state.webhooks.webhooks.find((webhook) => String(webhook.id) === String(id)) || null;
